import { useState } from 'react';
import { useSpring, animated } from '@react-spring/web';
import { 
    LOCATION_LIST, 
    LOCATION_CONFIG, 
    SEASON, 
    TIME_OF_DAY, 
    VIEW_MODE,
    MAP_IMAGE_SRC, 
    DEFAULT_SCENE_MEDIA
} from '../SceneComponents/VideoConfig.jsx';
import { playClickSound } from './SoundEffect'; 
import { InfoPopup } from './InfoPopup.jsx'; 

export default function DialogBox({
    title = "Die neue Tribschenstrasse\n– ein lebenswerter Strassenraum!",
    text,
    onHotspotClick,
    // 1. Accept the new props passed from Setup.jsx
    isInfoOpen,
    setIsInfoOpen
}) {
    // Note: Local state for isInfoOpen and isInfoHovered can be completely removed 
    // since Setup.jsx handles it now.

    const [springs, api] = useSpring(() => ({
        transform: 'translateY(0%)',
        opacity: 1,
    }));

    const handlePointSelect = (sceneMedia) => { 
        playClickSound(); 
        api.start({
            to: { transform: 'translateY(-200%)', opacity: 0 },
            onResolve: async () => {
                if (onHotspotClick) {
                    await onHotspotClick(sceneMedia);
                }
            }
        });
    };

    const handleBackgroundClick = () => {
        // 2. Uncomment this so clicks don't close the main dialog when the info popup is active
        if (isInfoOpen) {
            setIsInfoOpen(false);
            return; 
        }        
        const defaultMedia = DEFAULT_SCENE_MEDIA;
        handlePointSelect(defaultMedia);
    };

    return (
        <>
            {/* 3. Uncomment the backdrop and wrapper. Use setIsInfoOpen from props. */}
            <div 
                className={`info-backdrop-overlay ${isInfoOpen ? 'open' : ''}`}
                onClick={() => setIsInfoOpen(false)} 
            />

            <div className={`info-popup-wrapper ${isInfoOpen ? 'open' : ''}`}>
                <div style={{ pointerEvents: isInfoOpen ? 'auto' : 'none', width: '100%', height: '100%' }}>
                    <InfoPopup isOpen={isInfoOpen} onClose={() => setIsInfoOpen(false)} />
                </div>
            </div>

            <div className="overlay overlay-center" onClick={handleBackgroundClick}>
                <animated.div 
                    className="dialog-box" 
                    style={springs}
                >
                    <h2 className="dialog-box-title">{title}</h2>
                    
                    <div className="map-interaction-container">
                        <img src={MAP_IMAGE_SRC} alt="Tribschenstrasse Map" className="map-base-graphic" />
                        
                        {LOCATION_LIST.map((loc) => (
                            <button
                                key={loc.id}
                                className="ui-map-hotspot" 
                                style={{ 
                                    position: 'absolute', 
                                    top: loc.top, 
                                    left: loc.left 
                                }}
                                onClick={(e) => {
                                    e.stopPropagation(); 
                                    const targetMedia = LOCATION_CONFIG[loc.id].media[VIEW_MODE.PEDESTRIAN][SEASON.SPRING][TIME_OF_DAY.MORNING];
                                    handlePointSelect(targetMedia);
                                }}
                            />
                        ))}
                    </div>

                    <p className="dialog-box-text">{text}</p>
                    
                    {/* The previous pill-icon button remains commented out as you requested the text to trigger the action */}

                </animated.div>
            </div>
        </>
    );
}